<template>
  <v-container fluid class="background-bg full-height">
    <v-row justify="center" align="center" class="mt-12">
      <v-col sm="6" lg="3" md="4">
        <v-card class="pa-4 d-flex flex-column align-center">
          <div class="mt-2">
            <img class="card-logo" src="../assets/enel_foundation_logo.png" />
          </div>

          <div class="title mt-12 primaryText--text text-center">
            Open Africa 2021 Login
          </div>

          <v-form
            @submit.prevent="doLogin"
            class="px-4 mt-4 align-self-stretch d-flex flex-column"
          >
            <v-text-field
              flat
              v-model="email"
              name="email"
              label="Email"
              @blur="$v.email.$touch"
              required
              :error-messages="emailRequiredMessage"
            />
            <v-text-field
              flat
              v-model="password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              name="pass"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              @blur="$v.password.$touch"
              @click:append="showPassword = !showPassword"
              required
              :error-messages="passwordRequired"
            />

            <transition name="slide-fade">
              <v-alert v-if="hasError" type="error" class="caption pa-1 mt-4">{{
                this.errorMessage
              }}</v-alert>
            </transition>

            <v-btn
              class="mt-12 mx-12"
              :disabled="$v.$invalid"
              type="submit"
              color="accent"
              :loading="loading"
              >Login</v-btn
            >
          </v-form>

          <v-dialog v-model="showResetPasswordDialog" width="400" persistent>
            <v-btn
              slot="activator"
              color="accent"
              class="text-none mt-4"
              text
              @click="showResetPasswordDialog = true"
              >Forgot your password?</v-btn
            >

            <v-card :loading="resettingPassword" :disabled="resettingPassword">
              <v-card-title class="primaryText--text"
                >Reset Password</v-card-title
              >
              <v-card-text v-if="!resetPasswordSent">
                <v-form
                  @submit.prevent="resetUserPassword"
                >
                  <v-text-field
                    v-model="resetPasswordEmail"
                    label="Your Email"
                    placeholder="Enter your Email Address"
                  />
                  <transition
                    name="slide-fade"
                    v-if="resetPasswordErrorMessage"
                  >
                    <v-alert type="error" class="caption pa-1 mt-4">{{
                      this.resetPasswordErrorMessage
                    }}</v-alert>
                  </transition>
                  <div class="mt-6 d-flex align-center ma-0 pa-0">
                    <v-btn
                      color="accent"
                      text
                      @click="showResetPasswordDialog = false"
                      class="mr-3"
                      >Cancel</v-btn
                    >
                    <v-btn
                      :disabled="!canResetPassword"
                      color="accent"
                      type="submit"
                      :loading="resettingPassword"
                      >Send</v-btn
                    >
                  </div>
                </v-form>
              </v-card-text>
              <v-card-text v-else
                >Please check your email for further instructions</v-card-text
              >

              <!-- <v-card-actions v-if="!resetPasswordSent">
                <v-btn
                  color="accent"
                  text
                  @click="showResetPasswordDialog = false"
                  >Cancel</v-btn
                >
                <v-btn
                  :disabled="!canResetPassword"
                  color="accent"
                  type="submit"
                  form="reset-password-form"
                  :loading="resettingPassword"
                  >Send</v-btn
                >
              </v-card-actions> -->
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar bottom color="error" v-model="showToast">
      {{ toastMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
export default {
  name: "LoginScreen",
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      showToast: false,
      toastMessage: "Error",
      loading: false,
      resettingPassword: false,
      showPassword: false,
      showResetPasswordDialog: false,
      resetPasswordSent: false,
      resetPasswordEmail: "",
      resetPasswordErrorMessage: ""
    };
  },
  created() {},
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(5)
    }
  },
  computed: {
    hasError() {
      return this.errorMessage && this.errorMessage.length;
    },
    emailRequiredMessage() {
      const errors = [];
      if (!this.$v.email.$dirty) return [];
      !this.$v.email.required && errors.push("Email is required.");
      !this.$v.email.email && errors.push("Please enter a valid email address");
      return errors;
    },
    passwordRequired() {
      const errors = [];
      if (!this.$v.password.$dirty) return [];
      !this.$v.password.required && errors.push("Password is required");
      !this.$v.password.minLength &&
        errors.push("Password must be at least 5 characters long");
      return errors;
    },
    canResetPassword() {
      return this.resetPasswordEmail && this.resetPasswordEmail.length;
    }
  },
  methods: {
    ...mapActions("auth", {
      loginUser: "loginUser",
      resetPassword: "resetPassword"
    }),

    ...mapActions("profile", {
      getProfile: "getProfile",
      setProfile: "setProfile"
    }),

    async resetUserPassword() {
      this.resettingPassword = true;

      try {
        await this.resetPassword(this.resetPasswordEmail);
        this.resetPasswordSent = true;
        setTimeout(() => {
          this.showResetPasswordDialog = false;
          this.resetPasswordSent = false;
        }, 2000);
      } catch (error) {
        this.resetPasswordErrorMessage = error.message;
        setTimeout(() => {
          this.resetPasswordErrorMessage = "";
        }, 4000);
      } finally {
        this.resettingPassword = false;
        this.resetPasswordEmail = "";
      }
    },

    async doLogin() {
      this.loading = true;

      try {
        const user = await this.loginUser({
          email: this.email,
          password: this.password
        });

        //check wheather a user is a selector or an applicant
        if (user.type == "SELECTOR") {
          this.$router.replace({
            name: "dashboard"
          });
        } else {
          // try to fetch user profile
          // the getProfile will also update
          // the store state if needed

          await this.getProfile(user._id);

          // user successfully logged in. Route user to next screen
          this.$router.replace({
            name: "home"
          });
        }
      } catch (error) {
        this.errorMessage = error.message;
        setTimeout(() => {
          this.errorMessage = "";
        }, 2000);
      } finally {
        this.loading = false;
        this.password = "";
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<style scoped></style>
